module.exports = __webpack_public_path__ + "351c6e08126b62171cd7f2537f3dd102.svg";